<template>
  <div id="por-indicador">
    <div
      v-if="loadingPage || loadingData"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh"
    >
      <b-spinner large variant="primary"></b-spinner>
    </div>

    <div v-else>
      <div class="row mt-3">
        <div class="col-lg-4">
          <vue-select
            name="periodo"
            v-model="periodo"
            class="select-periodo"
            :clearable="false"
            :options="optionsPeriodo"
            label="label"
            placeholder="Período"
            @input="onChangePeriodo"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="col-lg-7">
          <vue-select
            id="select-tipo-equipe"
            name="tipo-equipe"
            v-model="selectedIndicador"
            class="select-tipo-equipe"
            :clearable="false"
            :options="optionsIndicadores"
            label="ds_indicador"
            placeholder="Todas"
            :disabled="disabledSelectIndicadores"
            @input="onChangeIndicador"
          >
            <template slot="option" slot-scope="option">
              {{ option.ds_indicador }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <dashboard-por-indicador
        :dadosDashboard="dadosPorIndicador"
        :periodo="periodo"
        :selectedIndicador="selectedIndicador"
      ></dashboard-por-indicador>
    </div>
  </div>
</template>

<script>
import DashboardPorIndicador from './components/DashboardPorIndicador'

export default {
  props: {
    loadingPage: {
      type: Boolean,
      default: false,
    },
    cadastros: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DashboardPorIndicador,
  },
  data() {
    return {
      dadosPorIndicadorOriginais: [],
      dadosPorIndicador: [],
      periodo: null,
      optionsPeriodo: [],
      loadingData: false,
      optionsIndicadores: [],
      selectedIndicador: {
        indicador: 56,
        ds_indicador: 'Vínculo e acompanhamento por parâmetro de cadastro',
      },
      disabledSelectIndicadores: true,
      indicadores: [],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
        this.periodo = this.optionsPeriodo[0]
        this.onChangePeriodo(this.periodo)
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    async onChangePeriodo(item) {
      let periodo = item.value.replace('/', '-')
      try {
        this.loadingData = true
        this.disabledSelectIndicadores = true
        // indicadores
        let response = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}/indicadores/${periodo}`
        )
        if (response) {
          this.optionsIndicadores = response.data
        }
        // dados por indicador
        let response2 = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}/indicadores/${periodo}/dados`
        )
        if (response2) {
          this.dadosPorIndicadorOriginais = response2.data
          this.dadosPorIndicador = response2.data
          this.onChangeIndicador(this.selectedIndicador)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingData = false
        this.disabledSelectIndicadores = false
      }
    },

    onChangeIndicador(item) {
      if (!item) {
        this.dadosPorIndicador = this.dadosPorIndicadorOriginais
        return
      }
      this.dadosPorIndicador = this.dadosPorIndicadorOriginais.filter((el) => {
        return el.indicador == item.indicador
      })
    },
  },
}
</script>

<style lang="scss">
#por-indicador {
}
</style>
